import React, { useEffect, useContext, useRef } from 'react';
import { makeStyles } from "@material-ui/core/styles";
import axios from 'axios';
import { getHeaders } from '../../../request';
import { TABAGISMO, PERMISSOES } from '../../../common/Constants';
import {
    SttTextItem,
    SttCircularProgress,
    SttTranslateHook,
    SttCtrlP
} from '@stt-componentes/core';
import { SttContentDrawer } from '@stt-componentes/core-v2';
import EnvioImagens from '../index';
import { temPermissaoRBAC } from '../../../secutity/rbac';
import { useSignal, useSignals } from '@preact/signals-react/runtime';
import usuario from '../../../signals/usuario';
import { NotificationManager } from 'react-notifications';
import { SECOES, REACT_KEYS } from './fieldNames';


const useStyles = makeStyles(theme => ({
    carregando: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        width: '100%'
    },
    conteinerLesao: {
        marginBottom: theme.spacing(1)
    }
}));

const Detalhes = ({ id, voltar }) => {
    const classes = useStyles();
    const { strings } = useContext(SttTranslateHook.I18nContext);
    const drawerRef = useRef();
    useSignals();

    const idComponenteEnvioImagens = useSignal(Math.random());
    const solicitacao = useSignal(null);
    const dadosEnvioImagens = useSignal([]);
    const mostrarModalEnvioImagens = useSignal(false);
    const comorbidades = useSignal([]);
    useEffect(() => {
        axios.get(`${global.gConfig.url_base_espiro}/solicitacao/${id}`, { headers: getHeaders() })
            .then((response) => {
                if (response.data) {
                    const { data } = response.data;
                    solicitacao.value = data;

                    dadosEnvioImagens.value = {
                        id: data.id_solicitacao,
                        instituicao: data.id_instituicao
                    };

                    comorbidades.value = data.comorbidades.map(c => c.descricao);
                }
            })
            .catch(err => console.log(err));
    }, []);

    const handleAbrirModalEnvioImagens = () => {
        console.log('ENTREEEI')
        idComponenteEnvioImagens.value = Math.random();
        mostrarModalEnvioImagens.value = true;
    }

    const callbackEnvioImagens = () => {
        voltar(true);
    }

    const callbackImpedirImpressao = () => {
        NotificationManager.error(strings.impressaoDesabilitada);
    };

    return (
        <>
            {
                !solicitacao.value
                    ?
                    <div className={classes.carregando}>
                        <SttCircularProgress color="primary" />
                    </div>
                    :
                    <>
                        <SttCtrlP callback={callbackImpedirImpressao} />
                        <SttContentDrawer
                            titulo={strings.solicitacao}
                            onClickVoltar={voltar}
                            ref={drawerRef}
                            secoesErro={[SECOES.DADOS_DO_EXAME, SECOES.DADOS_DO_PACIENTE, SECOES.INDICACAO_CLINICAS]}
                            botoes={[
                                {
                                    key: REACT_KEYS.BTN_ENVIAR_IMAGENS,
                                    descricao: strings.enviarImagens,
                                    variant: 'contained',
                                    color: 'secondary',
                                    show: temPermissaoRBAC(usuario, PERMISSOES.CRIAR_EXAME),
                                    onClick: handleAbrirModalEnvioImagens,
                                },
                            ]}
                            conteudo={[
                                {
                                    key: REACT_KEYS.DADOS_DO_EXAME,
                                    id: SECOES.DADOS_DO_EXAME,
                                    titulo: strings.dadosExame,
                                    show: true,
                                    children: (
                                        <div>
                                            <SttTextItem key="1" title={strings.modalidade} content={solicitacao.value.modalidade} />
                                            <SttTextItem key="2" title={strings.dataSolicitacao} content={`${solicitacao.value.data_solicitacao_formatada} ${global.gConfig.sufixo_data_hora}`} />
                                            <SttTextItem key="3" title={strings.solicitante} content={solicitacao.value.nome_solicitante} />
                                            <SttTextItem key="4" title={strings.cidadeUf} content={`${solicitacao.value.cidade} / ${solicitacao.value.uf}`} />
                                        </div>
                                    )
                                },
                                {
                                    key: REACT_KEYS.SEC_DADOS_DO_PACIENTE,
                                    id: SECOES.DADOS_DO_PACIENTE,
                                    titulo: strings.dadosPaciente,
                                    show: true,
                                    children: (
                                        <div>
                                            <SttTextItem key="5" title={strings.nome} content={solicitacao.value.nome_paciente} />
                                            <SttTextItem key="6" title={strings.dataNascimento} content={solicitacao.value.data_nascimento_paciente} />
                                            <SttTextItem key="7" title={strings.idade} content={`${solicitacao.value.idade_paciente} anos`} />
                                            <SttTextItem key="8" title={strings.genero} content={solicitacao.value.sexo_paciente} />
                                            <SttTextItem key="9" title={strings.cns} content={solicitacao.value.cartao_sus} />
                                            <SttTextItem key="10" title={strings.peso} content={solicitacao.value.peso_paciente} />
                                            <SttTextItem key="11" title={strings.altura} content={solicitacao.value.altura_paciente} />
                                            <SttTextItem key="12" title={strings.ocupacao} content={solicitacao.value.profissao_paciente} />
                                        </div>
                                    )
                                },
                                {
                                    key: REACT_KEYS.SEC_INDICACAO_CLINICAS,
                                    id: SECOES.INDICACAO_CLINICAS,
                                    titulo: strings.indicacaoClinica,
                                    show: true,
                                    children: (
                                        <div>
                                            <SttTextItem key="13" title={strings.tabagismo} content={solicitacao.value.descricacao_tabagismo} />
                                            {
                                                (solicitacao.value.tabagismo === TABAGISMO.FUMANTE || solicitacao.value.tabagismo === TABAGISMO.EX_FUMANTE) &&
                                                <>
                                                    <SttTextItem key="13.1" title={strings.cigarrosDia} content={solicitacao.value.cigarros_dia} />
                                                    <SttTextItem key="13.2" title={strings.anosFuma} content={solicitacao.value.anos_tabagismo} />
                                                </>
                                            }
                                            {
                                                solicitacao.value.tabagismo === TABAGISMO.EX_FUMANTE &&
                                                <>
                                                    <SttTextItem key="13.3" title={strings.anosParouFumo} content={solicitacao.value.anos_parou_fumar} />
                                                </>
                                            }
                                            <SttTextItem key="14" title={strings.etilismo} content={solicitacao.value.etilismo} />

                                            {comorbidades.length > 0 && <SttTextItem key="20" title={strings.comorbidades} content={comorbidades.join(', ')} />}
                                            {
                                                solicitacao.value.motivo_exame &&
                                                <SttTextItem key="15" title={strings.motivoExame} content={solicitacao.value.motivo_exame} />
                                            }
                                            {
                                                solicitacao.value.resumo_historia_clinica &&
                                                <SttTextItem key="16" title={strings.observacoes} content={solicitacao.value.resumo_historia_clinica} />
                                            }
                                            {
                                                solicitacao.value.hmf &&
                                                <SttTextItem key="17" title={strings.hmf} content={solicitacao.value.hmf} />
                                            }
                                            {
                                                solicitacao.value.hmp &&
                                                <SttTextItem key="18" title={strings.hmp} content={solicitacao.value.hmp} />
                                            }
                                            {
                                                solicitacao.value.medicamentos_em_uso &&
                                                <SttTextItem key="19" title={strings.medicamentosUso} content={solicitacao.value.medicamentos_em_uso} />
                                            }
                                        </div>
                                    )
                                },
                            ]}
                        />
                    </>
            }
            {
                temPermissaoRBAC(usuario, PERMISSOES.CRIAR_EXAME) &&
                <EnvioImagens
                    open={mostrarModalEnvioImagens.value}
                    resetFormulario={() => {
                        mostrarModalEnvioImagens.value = false;
                    }}
                    solicitacao={dadosEnvioImagens.value}
                    callbackFinalizarEnvio={callbackEnvioImagens}
                    key={idComponenteEnvioImagens.value}
                />
            }
        </>

    )

}

export default Detalhes;